
import { LedgerAccountVatField } from "@/models/ledger-account";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		value: {
			type: Number as ()=>LedgerAccountVatField
		},
		label: {
			type: String
		},
		fancy: Boolean
	},
	computed: {
		items():ISelectItem<LedgerAccountVatField>[]{
			return [
				LedgerAccountVatField.NONE,
				LedgerAccountVatField.AANKOPEN_HANDELSGOEDEREN,
				LedgerAccountVatField.DIENSTEN_OF_KOSTEN,
				LedgerAccountVatField.BEDRIJFSMIDDELEN
			].map(l=>{
				return {
					text: this.$ct(`common.ledger-account-vat-fields.${l}`),
					value: l
				};
			});
		}
	},
	methods: {
		onInput(value:LedgerAccountVatField){
			this.$emit("input", value);
		}
	}
});
